export function roundToCents(value) {
  if (value == null || value === "") return null;
  const number = Number(value);
  if (!Number.isFinite(number)) return null;
  const rounded =
    Math.round((Math.abs(number) + Number.EPSILON) * 100) / 100;
  return Object.is(number, -0) || number < 0 ? -rounded : rounded;
}

export function calculatePurchaseCost(parAmount, purchasePrice) {
  const par = Number(parAmount);
  const price = Number(purchasePrice);
  if (!Number.isFinite(par) || !Number.isFinite(price)) return null;
  return roundToCents((par * price) / 100);
}
